
import { useState } from 'react'
import { useDispatch } from 'react-redux'

import DialogTitle from '@mui/material/DialogTitle'
import Dialog from '@mui/material/Dialog'
import CloseIcon from '@mui/icons-material/Close'
import { DialogActions, DialogContent, IconButton } from '@mui/material'

import './validateProfit.css'
import { TextAreas } from '../../reusableUI/TextAreas'

import { iniRestartValidation } from '../../../redux/actions/pptos'

export const RestartValidation = ({ budgetId, open, setOpen }) => {

    const dispatch = useDispatch()
    const [comments, setComments] = useState('')
    const [msgError, setMsgError] = useState('')

    const handleRestart = () => {
        if (comments === '') {
            setMsgError('Falta ingresar un comentario')
            return false
        }

        dispatch(iniRestartValidation(budgetId, comments))
        setOpen(false)

    }

    const handleComentario = ({ target }) => {
        setComments(target.value)
    }

    return (
        <Dialog onClose={() => setOpen(false)} open={open} className='p-dialog-approve'>
            <DialogTitle className='ColorTitleDocument' id="scroll-dialog-title">
                <IconButton
                    aria-label="close"
                    style={{ padding: '0', float: 'right' }}
                    onClick={() => setOpen(false)}
                >
                    <CloseIcon
                        style={{ color: '#78667E' }}
                    />
                </IconButton>
            </DialogTitle>
            <DialogContent className='content'>
                <div className='d-flex justify-content-center p-icons'>
                    <i className='bi bi-arrow-clockwise' style={{ color: '#f85f6a', fontSize: '30px' }}></i>
                </div>
                <div className='text'>
                    <h3>Reiniciar validación</h3>
                    <p>¿Estás seguro de reiniciar</p>
                    <p>la validación?</p>

                    <p className='p-text-comments m-3'>
                        <TextAreas
                            label='Ingrese motivo'
                            name="comentario"
                            rows="2"
                            value={comments}
                            placeholder="Ingrese un motivo"
                            onChange={handleComentario}
                        />
                    </p>

                    <p className='p-text-emisor'>Se notificará al responsable de validar</p>

                    {msgError !== '' &&
                        <p style={{ color: 'red' }}>{msgError}</p>
                    }

                </div>
            </DialogContent>
            <DialogActions className='d-flex justify-content-center mt-3 mb-2 p-actions'>
                <button className='cancel' onClick={() => setOpen(false)}>Cancelar</button>
                <button className='approve' onClick={handleRestart}>Reiniciar</button>
            </DialogActions>
        </Dialog >
    );

}